export const blockIconsCommonactionsTodayNew = (
	<span className='material-symbols-outlined'>today</span>
);
